import React from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default function ButtonBlockComponent({
  buttonText,
  buttonLink,
  linkTarget,
  buttonColor,
  buttonModifiers,
  alignButton,
  topPadding,
  bottomPadding,
  backgroundColor,
  wrapperWidth,
  externalLinkOverride,
}) {
  const btnAlign = SelectionFactoryHelper.getFromSelectionFactory(alignButton)
  const tp = SelectionFactoryHelper.getFromSelectionFactory(topPadding)
  const bp = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding)
  const target = SelectionFactoryHelper.getFromSelectionFactory(linkTarget)
  const btnColor = SelectionFactoryHelper.getFromSelectionFactory(buttonColor)
  const btnMods = SelectionFactoryHelper.getFromSelectionFactory(buttonModifiers)
  const bgColor = SelectionFactoryHelper.getFromSelectionFactory(backgroundColor)
  const width = SelectionFactoryHelper.getFromSelectionFactory(wrapperWidth)

  return (
    <div className={`button-block ${tp ? tp : ""} ${bp ? bp : ""} ${bgColor ? bgColor : ""}`}>
      <div className={`${width ? width : "w--wider"} ${btnAlign ? btnAlign : ""}`}>
        <a href={externalLinkOverride || buttonLink} target={target ? target : undefined}>
          <button className={`button no-shadow ${btnColor ? btnColor : ""} ${btnMods ? btnMods : "button--medium"}`}>
            <span className="text">{buttonText}</span>
          </button>
        </a>
      </div>
    </div>
  )
}
